<template>
  <div id="service-page">
    <!-- site-navigation start -->
    <NavbarView />
    <!-- site-navigation end -->

    <!-- header begin -->
    <header class="page-head services-parallax-header">
      <div class="parallax-container">
        <!-- Background Layer -->
        <div class="layer-bg">
          <div class="grid"></div>
        </div>

        <!-- Middle Layer -->
        <div class="layer-mid">
          <div class="service-visual">
            <div class="code-editor">
              <div class="code-line"></div>
              <div class="code-line"></div>
              <div class="code-line"></div>
              <div class="code-line"></div>
            </div>
          </div>

          <div class="service-visual">
            <div class="ai-visual">
              <div class="neural-network" ref="neuralNetwork">
                <!-- Neural network nodes and connections will be generated dynamically -->
              </div>
            </div>
          </div>

          <div class="service-visual">
            <div class="marketing-visual">
              <div class="chart-bar" style="height: 40px; left: 20px"></div>
              <div class="chart-bar" style="height: 60px; left: 50px"></div>
              <div class="chart-bar" style="height: 30px; left: 80px"></div>
              <div class="chart-bar" style="height: 70px; left: 110px"></div>
              <div class="chart-bar" style="height: 50px; left: 140px"></div>
            </div>
          </div>
        </div>

        <!-- Foreground Layer -->
        <div class="layer-fg">
          <div class="service-icon-top">
            <i class="fa fa-code"></i>
            <div class="service-label">Development</div>
          </div>

          <div class="service-icon-top">
            <i class="fa fa-cogs"></i>
            <div class="service-label">Artificial Intelligence</div>
          </div>

          <div class="service-icon-top">
            <i class="fa fa-line-chart"></i>
            <div class="service-label">Digital Marketing</div>
          </div>
        </div>
      </div>

      <!-- Overlay content -->
      <div class="header-wrapper">
        <div class="container">
          <div class="row">
            <div class="col-md-12"></div>
          </div>
        </div>
        <!-- /.container -->
      </div>
      <!-- /.header-wrapper -->
    </header>
    <!-- /.page-head (header end) -->

    <div class="main-content">
      <!--  begin services section -->

      <section class="bg-white">
        <div class="container">
          <div class="headline text-center">
            <div class="row">
              <div class="col-md-6 col-md-offset-3">
                <h2 class="section-title">What We Do</h2>
                <p class="section-sub-title">
                  Custom digital solutions for your business
                </p>
                <!-- /.section-sub-title -->
              </div>
            </div>
          </div>
          <!-- /.headline -->

          <div class="service-list">
            <div class="row">
              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-umbrella"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">
                      Continuous Technical Support
                    </h3>
                    <p class="service-description">
                      Support and maintenance for systems, websites and servers
                      with fast and reliable service whenever you need it.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-thumbs-up"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Performance & Speed</h3>
                    <p class="service-description">
                      We deliver optimized solutions focused on fast loading,
                      responsiveness and scalability.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-bug"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Quality Code</h3>
                    <p class="service-description">
                      Our projects follow best practices, with automated testing
                      and code review to prevent production errors.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-cloud-download"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Websites & Landing Pages</h3>
                    <p class="service-description">
                      We develop sales pages, microsites and corporate websites
                      with professional design and conversion focus.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-tachometer"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Infrastructure & DevOps</h3>
                    <p class="service-description">
                      We handle automations, deployments, backups and monitoring
                      to ensure high availability and security for your systems.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>

              <div class="col-md-4">
                <div class="service-content text-center">
                  <div class="service-icon-box">
                    <div class="service-icon center-block">
                      <i class="fa fa-briefcase"></i>
                    </div>
                  </div>
                  <!--  end of .service-icon-box  -->
                  <div class="service-info">
                    <h3 class="service-heading">Marketing & Design</h3>
                    <p class="service-description">
                      We offer branding, SEO, social media advertising, custom
                      graphics and banners for your digital presence.
                    </p>
                  </div>
                  <!--   end of .service-info  -->
                </div>
                <!--  end of .service-content  -->
              </div>
            </div>
            <!--  end of .row  -->
          </div>
          <!--  end of .service-list  -->
        </div>
        <!-- end of .container -->
      </section>
      <!--  end of services section -->
    </div>
    <!--  end of .main-content  -->

    <FooterView />
  </div>
</template>

<script>
import NavbarView from "@/components/Navbar.vue";
import FooterView from "@/components/Footer.vue";

export default {
  name: "ServiceView",
  components: {
    NavbarView,
    FooterView,
  },
  mounted() {
    this.generateNeuralNetwork();
  },
  methods: {
    generateNeuralNetwork() {
      const neuralNetwork = this.$refs.neuralNetwork;
      if (!neuralNetwork) return;

      const nodeCount = 15;
      const nodes = [];

      // Create nodes
      for (let i = 0; i < nodeCount; i++) {
        const node = document.createElement("div");
        node.className = "neural-node";
        node.style.left = Math.random() * 150 + "px";
        node.style.top = Math.random() * 40 + "px";

        // Store position for connection calculations
        node.x = parseInt(node.style.left);
        node.y = parseInt(node.style.top);

        neuralNetwork.appendChild(node);
        nodes.push(node);
      }

      // Create connections between layers
      // Input layer (first 4 nodes) to hidden layer (next 6 nodes)
      for (let i = 0; i < 4; i++) {
        for (let j = 4; j < 10; j++) {
          this.createConnection(nodes[i], nodes[j], neuralNetwork);
        }
      }

      // Hidden layer to output layer (last 5 nodes)
      for (let i = 4; i < 10; i++) {
        for (let j = 10; j < nodeCount; j++) {
          this.createConnection(nodes[i], nodes[j], neuralNetwork);
        }
      }
    },
    createConnection(nodeA, nodeB, container) {
      const connection = document.createElement("div");
      connection.className = "connection";

      const dx = nodeB.x - nodeA.x;
      const dy = nodeB.y - nodeA.y;
      const length = Math.sqrt(dx * dx + dy * dy);
      const angle = (Math.atan2(dy, dx) * 180) / Math.PI;

      connection.style.width = length + "px";
      connection.style.height = "1px";
      connection.style.left = nodeA.x + 6 + "px";
      connection.style.top = nodeA.y + 6 + "px";
      connection.style.transform = `rotate(${angle}deg)`;

      container.appendChild(connection);
    },
  },
};
</script>

<style scoped>
/* Services Parallax Header Styles */
.services-parallax-header {
  position: relative;
  overflow: hidden;
  height: 157px;
}

.parallax-container {
  /* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

/* Background Layer */
.layer-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0a192f 0%, #112240 50%, #233554 100%);
  z-index: 1;
}

.layer-bg .grid {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.05) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 20px 20px;
  animation: gridMove 20s linear infinite;
}

/* Middle Layer */
.layer-mid {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 2;
}

.service-visual {
  width: 160px;
  height: 80px;
  background: rgba(10, 25, 47, 0.6);
  border-radius: 8px;
  border: 1px solid rgba(100, 255, 218, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.code-editor {
  width: 140px;
  height: 60px;
  padding: 10px;
}

.code-line {
  height: 6px;
  background: linear-gradient(90deg, #64ffda 0%, #1de9b6 100%);
  margin: 4px 0;
  border-radius: 2px;
  animation: codeTyping 2s ease-in-out infinite;
}

.code-line:nth-child(1) {
  width: 80%;
  animation-delay: 0s;
}
.code-line:nth-child(2) {
  width: 60%;
  animation-delay: 0.5s;
}
.code-line:nth-child(3) {
  width: 90%;
  animation-delay: 1s;
}
.code-line:nth-child(4) {
  width: 70%;
  animation-delay: 1.5s;
}

.ai-visual {
  width: 140px;
  height: 60px;
  position: relative;
}

.neural-network {
  width: 100%;
  height: 100%;
  position: relative;
}

.neural-node {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #64ffda;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(100, 255, 218, 0.5);
  animation: nodePulse 2s ease-in-out infinite;
}

.connection {
  position: absolute;
  background: rgba(100, 255, 218, 0.3);
  transform-origin: left center;
  animation: connectionFlow 3s ease-in-out infinite;
}

.marketing-visual {
  width: 140px;
  height: 60px;
  position: relative;
  padding: 10px;
  display: flex;
  align-items: end;
  justify-content: space-around;
}

.chart-bar {
  position: absolute;
  bottom: 10px;
  width: 20px;
  background: linear-gradient(0deg, #1de9b6 0%, #64ffda 100%);
  border-radius: 2px 2px 0 0;
  animation: chartGrow 3s ease-in-out infinite;
}

/* Foreground Layer */
.layer-fg {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 3;
}

.service-icon-top {
  width: 80px;
  height: 80px;
  background: rgba(10, 25, 47, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(100, 255, 218, 0.5);
  border: 2px solid rgba(100, 255, 218, 0.7);
  color: #64ffda;
  font-size: 32px;
  transition: all 0.3s ease;
  position: relative;
  animation: iconFloat 4s ease-in-out infinite;
}

.service-icon-top:hover {
  transform: scale(1.1);
  box-shadow: 0 0 40px rgba(100, 255, 218, 0.8);
}

.service-label {
  position: absolute;
  bottom: -40px;
  color: white;
  text-align: center;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 120px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
}

/* Header wrapper overlay */
.header-wrapper {
  position: relative;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.45);
  padding: 65px 0px;
}

/* Animations */
@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(20px, 20px);
  }
}

@keyframes codeTyping {
  0%,
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

@keyframes nodePulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}

@keyframes connectionFlow {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 0.6;
  }
}

@keyframes chartGrow {
  0% {
    transform: scaleY(0.3);
  }
  50% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0.7);
  }
}

@keyframes iconFloat {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  /* Simplify parallax layers for tablet */
  .layer-mid {
    opacity: 0.7;
    gap: 15px;
    justify-content: center;
  }

  .layer-fg {
    justify-content: center;
    gap: 25px;
    padding: 0 20px;
  }

  .service-visual {
    width: 80px;
    height: 50px;
  }

  .service-icon-top {
    width: 55px;
    height: 55px;
    font-size: 22px;
  }

  .service-label {
    font-size: 9px;
    width: 70px;
    bottom: -30px;
  }

  .code-editor,
  .marketing-visual {
    padding: 8px;
  }

  .code-line {
    height: 3px;
    margin: 2px 0;
  }

  .chart-bar {
    width: 10px;
  }

  /* Hide neural network visual on tablet for cleaner look */
  .service-visual:nth-child(2) {
    display: none;
  }

  /* Reduce grid animation intensity */
  .grid {
    opacity: 0.3;
    background-size: 25px 25px;
  }
}

@media (max-width: 480px) {
  /* Ultra-simplified mobile experience */
  .layer-mid {
    display: none; /* Hide all visual complexity on mobile */
  }

  .layer-fg {
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    gap: 15px;
    padding: 20px 10px;
  }

  .service-icon-top {
    width: 45px;
    height: 45px;
    font-size: 18px;
    position: relative;
  }

  .service-label {
    font-size: 7px;
    width: 50px;
    bottom: -25px;
    letter-spacing: 0.5px;
  }

  /* Simplify background grid */
  .grid {
    opacity: 0.2;
    background-size: 30px 30px;
  }

  /* Reduce animations for performance */
  .service-icon-top {
    animation: none;
  }

  /* Static icons on mobile - disable float animation */
  @keyframes iconFloat {
    0%,
    100% {
      transform: translateY(0px);
    }
  }
}
</style>
